export default __webpack_public_path__ + "images/I4.ef5168f.png";